module.exports = __webpack_public_path__ + "assets/img/dingbu.7ca8c62b.png";